import { useTranslation } from 'react-i18next'
import useDocumentTitle from '../../lib/useDocumentTitle'
import { PageHeader } from '@ant-design/pro-layout'
import { NotificationSettings } from '../../components/MyAccount/NotificationSettings'

export function SettingsPage() {
  const { t } = useTranslation()
  useDocumentTitle(t('frontend:myAccount.settingsPage.documentTitle'))

  return (
    <>
      <PageHeader
        style={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
        breadcrumb={{
          items: [
            {
              key: 'my-account',
              title: t('frontend:myAccount.breadcrumb.myAccount'),
            },
            {
              key: 'settings',
              title: t('frontend:myAccount.breadcrumb.settings'),
            },
          ],
        }}
        title={t('frontend:myAccount.settingsPage.title')}
      />
      <NotificationSettings />
    </>
  )
}
